import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXAccountAIModelPricing implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountAIModelPricingContainer";
    }
    render(){
        let self=this;
    }
}